import type Location from 'garaje/models/location';

/**
 * Whether the current user can sign out a visitor entry, given their edit / sign-out
 * abilities and the location's `employeeSignOutEnabled` configuration.
 *
 * When the host-sign-out restriction is on at the location
 * (`employeeSignOutEnabled === false`), only the explicit sign-out permission
 * authorizes. Otherwise either `canEdit` or `canSignOut` authorizes.
 */
export function canSignOutEntry({
  canEdit,
  canSignOut,
  location,
}: {
  canEdit: boolean;
  canSignOut: boolean;
  location: Location | null | undefined;
}): boolean {
  if (location?.visitorsConfiguration?.employeeSignOutEnabled === false) {
    return canSignOut;
  }
  return canEdit || canSignOut;
}
